import { deleteCookie, getCookies } from 'cookies-next/client';

// Stale dd_cookie_test_* cookies left behind by the Datadog SDK accumulate
// until requests overflow gateway header buffers:
// https://github.com/DataDog/browser-sdk/issues/4885
const DD_TEST_COOKIE_PREFIX = 'dd_cookie_test_';

let scheduled = false;

// A cookie can only be deleted with the same Domain attribute it was set
// with, and document.cookie doesn't expose it — so try host-only plus every
// parent domain.
function getDomainCandidates(hostname: string): Array<string | undefined> {
  const labels = hostname.split('.');
  return [
    undefined,
    ...labels.slice(0, -1).map((_, index) => labels.slice(index).join('.')),
  ];
}

export function clearDatadogTestCookies(): void {
  const names = Object.keys(getCookies() ?? {}).filter((name) =>
    name.startsWith(DD_TEST_COOKIE_PREFIX)
  );
  const domains = getDomainCandidates(window.location.hostname);

  for (const name of names) {
    for (const domain of domains) {
      deleteCookie(name, { path: '/', domain });
    }
  }
}

export function scheduleClearDatadogTestCookies(): void {
  if (scheduled) {
    return;
  }
  scheduled = true;

  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(() => clearDatadogTestCookies());
  } else {
    setTimeout(clearDatadogTestCookies, 0);
  }
}
